import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout'
import EmptyLayout from "@/layouts/EmptyLayout.vue";
import NavbarLayout from '@/layouts/NavbarLayout.vue'

import { updateMe } from '@/helpers/back'

function themedView(name) {
  return () => {
    const { useStore } = require('@/store/store')
    const store = useStore()
    const design = store.getP('design', 'default')
    return import(`@/design/${design}/${name}.vue`)
  }
}

const routes = [

  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: "Home",
        meta: {title: 'Видеохостинг для ваших любимых файлов'},
        component: themedView( 'MovieList' )
      },
      {
        path: 'movies/:genre',
        name: "Movies",
        meta: {title: 'Видеохостинг для ваших любимых файлов'},
        component: themedView( 'MovieList' )
      },
      {
        path: 'movie/:id',
        name: "movie",
        props: true,
        meta: {title: 'Видеохостинг для ваших любимых файлов'},
        component: themedView( 'MovieView' )
      },
    ],
  },

  {
    path: '/',
    component: NavbarLayout,
    children: [
       {
        path: 'maint/dash',
        name: "maint_dash",
        meta: {title: 'Maintenance Dashboard', requiresAuth: true},
        component: () => import( '@/views/maint/dash.vue' )
      },
       {
        path: 'top100',
        name: "top100",
        meta: {title: 'top100', requiresAuth: true},
        component: () => import( '@/views/content/Top100.vue' )
      },
       {
        path: 'customer/dashboard',
        name: "customer_dashboard",
        meta: {title: 'Зритель', requiresAuth: true},
        component: () => import( '@/views/customer/DashboardView.vue' )
      },
       {
        path: 'user/landing/list',
        name: "landing_list",
        meta: {title: 'Лендинги', requiresAuth: true},
        component: () => import( '@/views/landing/LandingList.vue' )
      },
       {
        path: 'user/texts/list',
        name: "texts_list",
        meta: {title: 'Новости', requiresAuth: true},
        component: () => import( '@/views/texts/TextsList.vue' )
      },
       {
        path: 'user/texts/:id',
        name: "texts_id",
        props: true,
        meta: {title: 'Новости', requiresAuth: true},
        component: () => import( '@/views/texts/TextView.vue' )
      },
      {
        path: 'user/movies',
        name: "movies",
        meta: {title: 'Загрузки', requiresAuth: true},
        component: () => import( '@/views/content/MoviesList.vue' )
      },
      {
        path: 'user/partners',
        name: "partners",
        meta: {title: 'Партнеры', requiresAuth: true},
        component: () => import( '@/views/partners/PartnersList.vue' )
      },
      {
        path: 'user/movie/edit/:id',
        name: "movie_edit",
        props: true,
        meta: {title: 'Редактирование Карточки Фильма', requiresAuth: true},
        component: () => import( '@/views/content/MovieEdit.vue' )
      },
      {
        path: 'user/movie/create',
        name: "movie_create",
        meta: {title: 'Создание Карточки Фильма', requiresAuth: true},
        component: () => import( '@/views/content/MovieEdit.vue' )
      },
      {
        path: 'user/comments',
        name: "comments",
        meta: {title: 'Комментарии', requiresAuth: true,},
        component: () => import( '@/views/content/CommentsList.vue' )
      },
      {
        path: 'user/domains/list',
        name: 'domains',
        meta: { title: 'Домены', requiresAuth: true},
        component: () =>
          import(
            '@/views/domains/DomainsList.vue'
          ),
      },
      {
        path: 'user/movies/parse',
        name: 'movies_parse',
        meta: { title: 'Парсинг фильмов', requiresAuth: true},
        component: () =>
          import(
            '@/views/content/MoviesParse.vue'
          ),
      },
      {
        path: 'user/movies/studios',
        name: 'movies_studios',
        meta: { title: 'Студии', requiresAuth: true},
        component: () =>
          import(
            '@/views/content/MoviesStudios.vue'
          ),
      },
      {
        path: 'user/movies/top',
        name: 'movies_top',
        meta: { title: 'Топ фильмов', requiresAuth: true},
        component: () =>
          import(
            '@/views/content/MoviesTop.vue'
          ),
      },
    ],
  },

  {
    path: '/',
    component: EmptyLayout,
    children: [
      {
        path: ":pathMatch(.*)*",
        component: () => import('@/views/pages/Page404'),
        props: true,
        meta: { title: "404" }
      },
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
        meta:{title:'Авторизация'}
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/pages/Register'),
        meta:{title:'Регистрация'}
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (!to.meta.requiresAuth) return next()

  try {
    if(await updateMe()) return next()
  } catch (err) {}

  // Не авторизован — редирект на /login, сохраняем исходный путь
  next({ path: '/login', query: { redirect: to.fullPath } })
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  document.title = routeTo.meta.title
  next()
})

const metrikaIds = [103285269];
router.afterEach((to) => {
  if (window?.ym) {
    metrikaIds.forEach(id => {
      window.ym(id, 'hit', to.fullPath);
    });
  }
});


export default router
